import styled from 'styled-components';
import { Colors } from '../../../config/theme';

type NavProps = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};
const Nav = ({ activeTab, setActiveTab }: NavProps) => {
  // const [notifications, setNotifications] = useState(false);

  return (
    <NavStyled>
      <div className="d-flex">
        <p
          style={{ cursor: 'pointer' }}
          onClick={() => setActiveTab('listing-details')}
          className={`nav-link-btn ${
            activeTab === 'listing-details' ? 'active' : ''
          }`}
        >
          Listing Information
        </p>
        {/* <p // TODO - add this back in when ready
          style={{ cursor: 'pointer' }}
          onClick={() => setActiveTab('sales')}
          className={`nav-link-btn ${activeTab === 'sales' ? 'active' : ''}`}
        >
          Sales
        </p>
        <p // TODO - add this back in when ready
          style={{ cursor: 'pointer' }}
          onClick={() => setActiveTab('reviews')}
          className={`nav-link-btn ${activeTab === 'reviews' ? 'active' : ''}`}
        >
          Reviews
        </p>

        <p // TODO - add this back in when ready
          style={{ cursor: 'pointer' }}
          onClick={() => setActiveTab('preview')}
          className={`nav-link-btn ${activeTab === '/preview' ? 'active' : ''}`}
        >
          Preview
        </p> */}
      </div>
      <div className="position-relative">
        {/* <NotificationBtn  // TODO - add this back in when ready
          className={`new ${notifications ? 'active' : ''}`}
          onClick={() => setNotifications(!notifications)}
        >
          <NotificationIcon />
        </NotificationBtn>
        <NotificationMenu className={notifications ? 'active' : ''}>
          <div className="head">
            <h6 className="f-medium mb-0">Your notifications</h6>
            <span className="text-white">3 New</span>
          </div>
          <div>
            {notificationsData.map((notif, i) => (
              <Notification
                key={i}
                Icon={notif.icon}
                iconClr={notif.clr}
                status={notif.status}
                title={notif.title}
                descp={notif.descp}
                time={notif.time}
              />
            ))}
          </div>
          <h6 className="f-medium mb-0">Previous notifications</h6>
          <div>
            <Notification
              Icon={NotifiMsgIcon}
              iconClr="blue"
              status="old"
              title="Silal Management"
              descp="The refund on the order #247hw9 has been completed."
              time="10m"
            />
          </div>
        </NotificationMenu> */}
      </div>
    </NavStyled>
  );
};

const NavStyled = styled.nav`
  margin-top: 19px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  .menu {
    border: none;
    background-color: transparent;
    margin-right: 20px;
    line-height: 1;
    margin-bottom: 15px;
    svg {
      width: 19px;
    }
  }
  .nav-link-btn {
    display: block;
    margin-right: 20px;
    padding: 5px 10px;
    height: 32px;
    border-radius: 5px;
    text-decoration: none;
    color: #4c6870;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 15px;
    white-space: nowrap;
    transition: background-color 0.2s linear;
    &:hover {
      background: #b4e1db57;
      /* color: white;
      span {
        color: white;
      } */
    }
    &.active {
      background: ${Colors.greenMain};
      color: white;
      span {
        color: white;
      }
    }
    span {
      color: #a0afb4;
    }
  }
  .link {
    svg {
      width: 42px;
    }
  }
`;

export default Nav;
